// extracted by mini-css-extract-plugin
export default {"emblaViewport":"ZkpaWkGSMA-qe3AAwZnTVg==","emblaContainer":"_72hq2fOlBzslSEiR+wyy+g==","emblaSlide":"_0QTORWUgm0NxjDpVnFGtvQ=="};